import type { ComponentProps } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';

import {
  styledFacadeGradientClass,
  styledFacadeImageClass,
  styledFacadeTitleClass,
  styledIframeClass,
  styledPlayButtonClass,
  videoRatioClass,
} from './Video.css';

export const VideoRatio = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={getClassNames(videoRatioClass, className)} {...props} />
);

export const StyledFacadeImage = ({ className, ...props }: ComponentProps<'img'>) => (
  <img alt="" className={getClassNames(styledFacadeImageClass, className)} {...props} />
);

export const StyledFacadeGradient = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={getClassNames(styledFacadeGradientClass, className)} {...props} />
);

export const StyledFacadeTitle = ({ className, ...props }: ComponentProps<'a'>) => (
  <a className={getClassNames(styledFacadeTitleClass, className)} {...props} />
);

export const StyledPlayButton = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={getClassNames(styledPlayButtonClass, className)} {...props} />
);

export const StyledIframe = ({ className, ...props }: ComponentProps<'iframe'>) => (
  <iframe className={getClassNames(styledIframeClass, className)} {...props} />
);
